module.exports = __webpack_public_path__ + "static/media/9-8.977605c2.mp3";